export const DIARY_MEMORY_TYPES = [
  'medical',
  'goal',
  'preference',
  'constraint',
  'life_context',
  'nutrition',
  'training',
] as const;

export type DiaryMemoryType = (typeof DIARY_MEMORY_TYPES)[number];

export const DIARY_MEMORY_FACT_KINDS = ['name'] as const;

export type DiaryMemoryFactKind = (typeof DIARY_MEMORY_FACT_KINDS)[number];

export const DIARY_MEMORY_SOURCES = [
  'manual',
  'chat_explicit',
  'chat_suggested',
  'vault_import',
] as const;

export type DiaryMemorySource = (typeof DIARY_MEMORY_SOURCES)[number];

export const DIARY_MEMORY_STATUSES = ['active', 'archived'] as const;

export type DiaryMemoryStatus = (typeof DIARY_MEMORY_STATUSES)[number];

export interface DiaryMemory {
  id: string;
  title: string;
  body: string;
  memory_type: DiaryMemoryType;
  source: DiaryMemorySource;
  confidence: number;
  user_confirmed: boolean;
  is_pinned: boolean;
  status: DiaryMemoryStatus;
  expires_at: string | null;
  metadata: Record<string, unknown>;
  origin_chat_session_id: string | null;
  origin_chat_message_id: string | null;
  origin_vault_document_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface DiaryMemoryDraft {
  title?: string;
  body: string;
  memory_type?: DiaryMemoryType;
  source?: DiaryMemorySource;
  confidence?: number;
  user_confirmed?: boolean;
  is_pinned?: boolean;
  status?: DiaryMemoryStatus;
  expires_at?: string | null;
  metadata?: Record<string, unknown>;
  origin_chat_session_id?: string | null;
  origin_chat_message_id?: string | null;
  origin_vault_document_id?: string | null;
}

export interface DiaryMemorySuggestionRequest {
  user_message: string;
  assistant_message: string;
  language?: string;
  session_id?: string | null;
  user_message_id?: string | null;
  assistant_message_id?: string | null;
}

export interface DiaryMemorySuggestion {
  should_save: boolean;
  title?: string;
  body?: string;
  memory_type?: DiaryMemoryType;
  fact_kind?: DiaryMemoryFactKind | null;
  confidence?: number;
  reason?: string;
}

export interface DiarySummary {
  total: number;
  pinned: number;
  constraints: number;
  medical: number;
  lastUpdatedAt: string | null;
}

export interface DiaryContextSummary {
  total_active: number;
  pinned: number;
  constraints: number;
  last_updated_at: string | null;
}

export interface DiaryContext {
  summary: DiaryContextSummary;
  identity_facts: DiaryMemory[];
  active_constraints: DiaryMemory[];
  recent_memories: DiaryMemory[];
}
